import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo"
import PageHeaderTitle from "../components/PageHeaderTitle/PageHeaderTitle"
import ScrollAnimation from "react-animate-on-scroll"
import ContactSections from "../components/ContactSections/ContactSections"

class ContactPage extends React.Component {
  render() {
    return (
      <Layout>
        <SEO title="Kontakt | Kierownik budowy Recz - Dawid Mroczek" />
        <PageHeaderTitle text="Kontakt" />
        <ContactSections />
      </Layout>
    )
  }
}

export default ContactPage
